import _ from 'lodash';
import { AnyAction } from 'redux';
import { updateInfoBadgeCountOfSideBarHeader } from 'src/adminPanel/components/sideBar/sideBarMenuItems';
import { ROUTE_ADMIN_OFFICE_ADDRESS_CONFIRMATION } from 'src/config/routes';
import { singleEntityDefaultState, SingleEntityState } from 'src/store/entities/types/SingleEntityState';
import { FAILURE_ADDRESS_CONFIRMATIONS, REQUEST_ADDRESS_CONFIRMATIONS, SUCCESS_ADDRESS_CONFIRMATIONS } from './actions';

export function addressConfirmationsReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ADDRESS_CONFIRMATIONS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ADDRESS_CONFIRMATIONS:
            ROUTE_ADMIN_OFFICE_ADDRESS_CONFIRMATION.infoBadgeCount = action.response.data.totalElements || 0;
            updateInfoBadgeCountOfSideBarHeader();
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_ADDRESS_CONFIRMATIONS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
